<app-com-tip *ngIf="isShowTip" (onCancel)="exitTip()" [desText]="desText" [cancelText]="'知道了'" [sureText]="''" ></app-com-tip>
<app-questionnaire [enter]="0" [learningPathMetaId]="learningPathMetaId" [isShowQuestionnaire]="isShowQuestionnaire" (onExit)="closeQuestionnaire()"></app-questionnaire>
<div *ngIf="learningPath&&mode&&status">
  <div *ngIf="abilityBack" class="common-back-btn-sight" id="backBtn"  (click)="goToLearningMap()" style="top:.1rem">
    <i class="fa fa-angle-left icon"></i>
  </div>

  <div id="wordsWrap" >
    <div id="title" class="fontSize18">
      {{appRename.getShowName(learningPath.name)}}
    </div>
    <div id="content" class="fontSize16" [innerHtml]="learningPath.description">
    </div>
  </div>

  <div id="cardsWrap">
    <div class="card card_{{mode}}_{{i+1}}" (click)="cardClick(i)" *ngFor="let item of learningPath.subItems;let i=index">
      <div class="cardNumber fontSize36">{{i+1}}</div>
      <div class="cardTitle fontSize18">
        <span *ngIf="item.type==0">引导</span>
        <span *ngIf="item.type==1">能力诊断</span>
        <span *ngIf="item.type==2">课程学习</span>
        <span *ngIf="item.type==3">情景模拟</span>
        <span *ngIf="item.type==4">能力考核</span>
      </div>
      <img src="{{assetsRoute}}/picture/learningmap/icon{{item.type+1}}.png" alt="" class="cardImage{{item.type+1}}">
      <!--<div class="block" *ngIf="learningPath.currentItemIndex<i&&status==1||status!=1&&(item.type==0||item.type==1||item.type==4)">-->
      <div class="block" *ngIf="learningPath.currentItemIndex<i&&status==1">
        <i class="fa fa-lock icon lock fontSize32"></i>
      </div>
    </div>
  </div>
</div>

<!--多余的提示注释掉-->
<!--<div id="shade" (click)="hideTip()" *ngIf="tryout"></div>-->
<!--<div id="shade2" (click)="hideTip2()"></div>-->

<!--<div id="mengban" *ngIf="mengban">-->
  <!--<div id="baikuang">-->
    <!--<p class="fontSize14">更多体验，请点击申请。</p>-->
    <!--<button class="fontSize16" id="shiyong" (click)="shiyong()">申请试用</button>-->
  <!--</div>-->
  <!--<div id="closeBtn" (click)="closeTip()">-->
  <!--</div>-->
<!--</div>-->

<!--<div id="tip" class="fontSize16" *ngIf="tryout">-->
  <!--<div>-->
    <!--您已体验完毕，更多体验，请点击申请。-->
  <!--</div>-->

  <!--<div id="tipBtn" class="fontSize14" (click)="try()">-->
    <!--申请试用-->
  <!--</div>-->
<!--</div>-->

<!--<div id="tip2" class="fontSize16">
  <div>
    更多体验，请点击申请。
  </div>

  <div id="tipBtn2" class="fontSize14" (click)="try()">
    申请试用
  </div>
</div>-->

<div id="toast1" class="fontSize16">
  学之有序，请先完成前面的练习
</div>



// WEBPACK FOOTER //
// ./src/app/learning-path-new.component.html